import React, {useEffect, useState, useMemo} from "react";
import {RouteComponentProps, useHistory, useParams} from "react-router-dom";
import {InitialStateUIType, InitialStateUserType} from "../../typings/state";
import { CompetencyTestDetailFullType, CompetencyTestSection } from "../../typings/competency-test";
import {useDispatch, useSelector} from "react-redux";
import {useQuery} from "react-query";
import {authenticatedRequest, authenticatedRequestRaw} from "../../services/api.service";
import {toast} from "react-toastify";
import { useBreadcrumbSetter } from "../../hooks/useBreadcrumbSetter";
import {LOADING_UI, UNLOADING_UI} from "../../redux/types";
import Button from "../../components/UI/Button";
import dayjs from 'dayjs'
import {MemberAnswerType} from "../../typings/activity";

interface CompetencyTestProps extends RouteComponentProps{
	user: InitialStateUserType;
	UI: InitialStateUIType;
}
const Detail: React.FC<CompetencyTestProps> = () => {
	const history  = useHistory();
	const dispatch = useDispatch();
	const params:any  = useParams();
	const [testId, setTestId] = useState<number | null>(null);
	const [competency, setCompetency] =
    useState<CompetencyTestDetailFullType | null>(null);
	const user = useSelector((state: {user: InitialStateUserType}) => state.user)
	const { data, refetch, isFetching } = useQuery('competencyDetail', async () => {
		try{
			const response = await authenticatedRequest('GET','/competency-test/' + testId)
			return response?.data
		}catch (e: any) {
			toast.error(e?.message ?? 'Terjadi Kesalahan. Silahkan coba lagi beberapa saat', {
				position: toast.POSITION.TOP_CENTER
			});
			history.push(`/competency`)
		}
		return null
	}, {enabled: false})
	useEffect(() => {
		if(Number.isNaN(Number(params?.id))){
			history.push('/dashboard')
		}
		setTestId(Number(params?.id));
	},[params?.id, history])
	useEffect(() => {
		if(testId){
			refetch();
		}
	},[testId, refetch]);
	useEffect(() => {
		if(data){
			// @ts-ignore
			setCompetency(data)
		}
	},[data]);

	// Set custom breadcrumbs when competency data is loaded
	const breadcrumbs = useMemo(() => {
		return competency ? [
			{ label: competency?.category?.name, path: '/competency/cat/' + competency?.category?.code },
			{ label: competency.title, isLast: true }
		] : [];
	}, [competency]);

	useBreadcrumbSetter(breadcrumbs);
	useEffect(() => {
		if(isFetching){
			dispatch({ type: LOADING_UI })
		}else{
			dispatch({ type: UNLOADING_UI })
		}
	},[isFetching, dispatch])
	const startTest = async () => {
		dispatch({ type: LOADING_UI });
		try {
			await authenticatedRequestRaw('POST', '/competency-test/pretest', {
				id: testId,
			});
			history.push(`/competency/${testId}/test`);
		} catch (err: any) {
			const errorMsg =
				err?.response?.data?.message ||
				err?.message ||
				'Gagal memulai tes. Silahkan coba lagi beberapa saat.';
			toast.error(errorMsg, {
				position: toast.POSITION.TOP_CENTER,
			});
		} finally {
			dispatch({ type: UNLOADING_UI });
		}
	};
	const getDuration = (start_date: string, end_date: string) => {
		const startDate = dayjs(start_date)
		const endDate = dayjs(end_date)
		const diffMinute = endDate.diff(startDate,'minutes');
		const minuteSecond = diffMinute * 60;
		const diffSecond = endDate.diff(startDate,'second');
		return <>
			{diffMinute} Menit {diffSecond - minuteSecond} Detik
		</>
	}
	const calculateScoreSection = (section: CompetencyTestSection) => {
		const qIds = section?.questions.map(q => q.id)
		const memberAnswer: MemberAnswerType[] = JSON.parse(competency?.memberTest?.member_answer as any) as MemberAnswerType[]
		const filterAnswer = memberAnswer.filter(ma => qIds.includes(ma.id))
		const score = filterAnswer.reduce(function (sc, item) { return Number(sc) + Number(item.score) }, 0);
		const formattedScore = Math.round(Number(score) * 100) / 100;
		return <tr>
			<td>{section.name}</td>
			<td className="font-bold">{formattedScore}</td>
		</tr>
	}
	const DisplayButton = () => {
		if(competency?.memberTest){
			if(competency?.memberTest?.end_date === null || competency?.memberTest?.end_date === undefined){
				return (
					<>
						<div className="p-4 rounded border bg-yellow-50 border-yellow-200 text-yellow-800 mb-4">
							Anda masih melakukan test ini. klik tombol dibawah ini untuk melanjutkan.
						</div>
						<Button primary onClick={() => history.push(`/competency/${testId}/test`)} className="w-3/4 gradient-primary">
							Lanjutkan Test
						</Button>
					</>
				)
			}else{
				return (
          <div className="w-full flex flex-col">
            {competency?.memberTest?.member_answer && (
              <>
                <div className="p-4 rounded border bg-green-50 border-green-200 text-green-800 mb-3 w-full flex justify-center">
                  Anda telah menyelesaikan tes ini.
                </div>
                <div className="flex w-full justify-center mb-3">
                  <Button
                    primary
                    onClick={startTest}
                    className="w-full gradient-primary"
                  >
                    Coba Kembali
                  </Button>
                </div>
                <div className="bg-white rounded-lg shadow border flex flex-col items-center w-full mb-3">
                  <div className="px-4 py-3 border-b gradient-primary rounded-t-lg w-full text-white text-center">
                    <span className={"card-title font-bold"}>Nama</span>
                  </div>
                  <div className="p-4">
                    <div className="font-bold">{user.profile?.fullname}</div>
                  </div>
                </div>
              </>
            )}
            <div className="flex flex-col w-full" style={{ gap: "16px" }}>
              <div className="bg-white rounded-lg shadow border flex flex-col items-center w-full">
                <div className="px-4 py-3 border-b  rounded-t-lg w-full bg-secondary text-white text-center">
                  <span className={"card-title font-bold"}>Nilai</span>
                </div>
                {competency?.memberTest?.member_answer ? (
                  <div className="w-full p-4">
                    {/*<span className="font-bold" style={{fontSize: '48px',lineHeight:1}}>{competency.memberTest.score}</span>*/}
                    <table className="table table-bordered w-full">
                      <tbody>
                        {competency?.sections?.map((s) => {
                          return calculateScoreSection(s);
                        })}
                        <tr>
                          <td className="font-bold">Total Nilai</td>
                          <td className="font-bold">
                            {Math.round(Number(competency.memberTest.score) * 100) / 100}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="p-4 w-full flex justify-center">
                    <p className="text-center text-red-600">
                      Anda tidak menyelesaikan test ini
                    </p>
                  </div>
                )}
              </div>
              {competency?.memberTest?.member_answer && (
                <>
                  <div className="bg-white rounded-lg shadow border flex flex-col items-center w-full">
                    <div className="px-4 py-3 border-b rounded-t-lg w-full text-white text-center gradient-accent">
                      <span className={"card-title font-bold"}>
                        Waktu Pengerjaan
                      </span>
                    </div>
                    <div className="p-4">
                      <div className="font-bold fs-7">
                        {competency.memberTest.start_date} -{" "}
                        {competency.memberTest.end_date}
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg shadow border flex flex-col items-center w-full">
                    <div className="px-4 py-3 border-b rounded-t-lg w-full bg-primary text-white text-center">
                      <span className={"card-title font-bold"}>Durasi</span>
                    </div>
                    <div className="p-4">
                      <div className="font-bold">
                        {getDuration(
                          competency.memberTest.start_date,
                          competency.memberTest.end_date
                        )}
                      </div>
                    </div>
                  </div>
                  <Button
                    primary
                    onClick={() => history.push(`/competency/${testId}/review`)}
                    className="w-full my-3 bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-2.5 rounded-lg shadow-sm flex items-center justify-center"
                  >
                    <span>Lihat Pembahasan & Kunci Jawaban</span>
                  </Button>
                </>
              )}
              {competency?.competenciesList && (
                <div className="bg-white rounded-lg shadow border flex flex-col items-center w-full mb-3">
                  <div className="px-4 py-3 border-b  rounded-t-lg w-full bg-blue-300 text-center">
                    <span className={"card-title font-bold"}>
                      Percobaan Lainnya
                    </span>
                  </div>
                  <div className="p-4 w-full table-responsive">
                    <table className="table w-full">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Tanggal</th>
                          <th scope="col">Nilai</th>
                        </tr>
                      </thead>
                      <tbody>
                        {competency?.competenciesList.map((c, index) => (
                          <tr key={`competency-${c.id || index}`}>
                            <td className="text-center">{index + 1}</td>
                            <td className="text-center">{c.start_date}</td>
                            <td className="text-center">{Math.round(Number(c.score) * 100) / 100}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
			}
		}
		return (
			<Button primary onClick={startTest} className="w-full gradient-primary">
				Mulai
			</Button>
		)
	}
	return (
		<div className="w-full p-4">
			<img src={competency?.image ?? 'https://placehold.co/200x200'}
			     alt={competency?.title || 'Competency Test'} className="mb-4 w-full"
			     style={{maxHeight: '200px', objectFit: 'cover'}}
			/>
			<h4 className="mb-3 font-bold text-xl">{competency?.title}</h4>
			<p className="text-left w-full mb-4">{ competency?.description }</p>
			<p className="text-left w-full mb-4">
				Asesmen ini terdiri dari <strong>{competency?.sections?.length ?? 0}</strong> Bagian dengan durasi <strong>{competency?.duration} Menit</strong>
				{' '}dan total soal <strong>{competency?.totalQuestions} Soal</strong>
			</p>
			<div className="flex flex-col justify-center items-center">
				<DisplayButton />
			</div>
		</div>
	)
}

export default Detail
